// Componente Profile para mostrar y editar información del usuario
// Página de perfil personal con datos básicos

import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { FiUser, FiMail, FiCalendar, FiEdit2 } from 'react-icons/fi';

/**
 * Componente Profile
 * 
 * Página de perfil del usuario autenticado
 * Muestra información personal y permite edición básica
 */
const Profile = () => {
  const { user } = useAuth();

  // Formatea la fecha de creación del usuario
  const formatDate = (dateString) => {
    if (!dateString) return 'No disponible';
    return new Date(dateString).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <div className="max-w-4xl mx-auto">
      {/* Encabezado */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Mi Perfil</h1>
        <p className="mt-2 text-gray-600">
          Gestiona tu información personal y preferencias
        </p>
      </div>

      {/* Tarjeta de perfil principal */}
      <div className="bg-white rounded-lg shadow mb-6">
        <div className="p-6">
          {/* Avatar y información básica */}
          <div className="flex items-center space-x-6 mb-6">
            {/* Avatar */}
            <div className="flex-shrink-0">
              <div className="h-20 w-20 bg-gray-300 rounded-full flex items-center justify-center">
                <FiUser className="h-10 w-10 text-gray-600" />
              </div>
            </div>

            {/* Información del usuario */}
            <div className="flex-1">
              <h2 className="text-xl font-semibold text-gray-900">
                {user?.email || 'Usuario'}
              </h2>
              <p className="text-sm text-gray-500">
                Miembro desde: {formatDate(user?.created_at)}
              </p>
              <div className="mt-3">
                <button className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors">
                  <FiEdit2 className="h-4 w-4 mr-2" />
                  Editar Perfil
                </button>
              </div>
            </div>
          </div>

          {/* Información detallada */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Información de cuenta */}
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-4">
                Información de Cuenta
              </h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <FiMail className="h-5 w-5 text-gray-400" />
                  <div>
                    <p className="text-sm font-medium text-gray-900">Correo Electrónico</p>
                    <p className="text-sm text-gray-600">{user?.email || 'No disponible'}</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <FiCalendar className="h-5 w-5 text-gray-400" />
                  <div>
                    <p className="text-sm font-medium text-gray-900">Fecha de Registro</p>
                    <p className="text-sm text-gray-600">{formatDate(user?.created_at)}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Estadísticas */}
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-4">
                Estadísticas de Actividad
              </h3>
              <div className="space-y-4">
                <div className="bg-gray-50 rounded-lg p-4">
                  <p className="text-sm font-medium text-gray-900">Sesiones Totales</p>
                  <p className="text-2xl font-semibold text-blue-600">47</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-4">
                  <p className="text-sm font-medium text-gray-900">Última Actividad</p>
                  <p className="text-sm text-gray-600">Hoy, 10:30 AM</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sección de preferencias */}
      <div className="bg-white rounded-lg shadow">
        <div className="p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">
            Preferencias de Notificación
          </h3>
          <div className="space-y-4">
            <label className="flex items-center">
              <input
                type="checkbox"
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                defaultChecked
              />
              <span className="ml-2 text-sm text-gray-700">
                Recibir notificaciones por correo electrónico
              </span>
            </label>
            <label className="flex items-center">
              <input
                type="checkbox"
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                defaultChecked
              />
              <span className="ml-2 text-sm text-gray-700">
                Notificaciones de actividad del sistema
              </span>
            </label>
            <label className="flex items-center">
              <input
                type="checkbox"
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <span className="ml-2 text-sm text-gray-700">
                Actualizaciones de seguridad
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
